import { ReactComponent as MsgOutlineIcon } from 'assets/images/icons/message_outline.svg';
import { ReactComponent as MsgFilledIcon } from 'assets/images/icons/message_filled.svg';

import { useSubstitutionFlowStatusChip } from './hooks';

import makeClasses from './SubstitutionFlowStatusChip.style';

import type { Props } from './substitutionFlowStatusChip.model';

export function SubstitutionFlowStatusChip(props: Props) {
  const { status, deletedAt, size = 'regular', variant = 'primary' } = props;

  const {
    lang,
    isRender,
    countdownRef,
    showCountdown,
  } = useSubstitutionFlowStatusChip({ status, deletedAt });

  const TheIcon = variant === 'primary' ? MsgOutlineIcon : MsgFilledIcon;

  const _classes = makeClasses({ size, variant, status });

  if (!isRender) return null;
  return (
    <div
      role='status'
      aria-live='polite'
      aria-label='subtitution-flow-status-chip'
      data-status={status}
      className={_classes.root}
    >
      <TheIcon aria-label='icon' />
      <span aria-label='label'>
        {`${lang.label}${showCountdown ? ' ' : ''}`}
        <span aria-label='countdown' ref={countdownRef} />
      </span>
    </div>
  );
}
